export default "__VITE_ASSET__DDL9JaW1__"